import { render, staticRenderFns } from "./cliu.vue?vue&type=template&id=5544a2c6&scoped=true&"
import script from "./cliu.vue?vue&type=script&lang=js&"
export * from "./cliu.vue?vue&type=script&lang=js&"
import style0 from "./cliu.vue?vue&type=style&index=0&id=5544a2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5544a2c6",
  null
  
)

export default component.exports